import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "space-y-6 ml-4" }
const _hoisted_2 = { class: " text-xl font-semibold text-gray-lp-300" }
const _hoisted_3 = {
  key: 0,
  class: "rounded-lg overflow-hidden border border-gray-lp-1400"
}
const _hoisted_4 = { class: "min-w-full divide-y divide-gray-lp-1400" }
const _hoisted_5 = { class: "text-gray-lp-300 text-sm font-semibold text-left bg-gray-lp-2500" }
const _hoisted_6 = /*#__PURE__*/_createVNode("th", { class: "px-6 py-3" }, "No", -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("th", { class: "px-6 py-3" }, "ID POS", -1)
const _hoisted_8 = { class: "px-6 py-3" }
const _hoisted_9 = /*#__PURE__*/_createVNode("th", { class: "px-6 py-3" }, "District", -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("th", { class: "px-6 py-3" }, "3LC", -1)
const _hoisted_11 = { class: "divide-y divide-gray-lp-1400 bg-white" }
const _hoisted_12 = { class: "px-6 py-4 whitespace-nowrap" }
const _hoisted_13 = { class: "px-6 py-4 whitespace-nowrap" }
const _hoisted_14 = { class: " px-4 py-4 whitespace-nowrap" }
const _hoisted_15 = { class: "px-6 py-4 whitespace-nowrap" }
const _hoisted_16 = { class: "flex items-center" }
const _hoisted_17 = {
  class: "flex flex-nowrap gap-2 overflow-hidden max-w-full pr-4",
  style: {"line-height":"24px","max-height":"24px"}
}
const _hoisted_18 = { class: "inline-block bg-gray-lp-2500 text-gray-lp-300 font-medium text-sm rounded-md px-2 py-1" }
const _hoisted_19 = { class: "px-6 py-4 whitespace-nowrap" }
const _hoisted_20 = {
  key: 1,
  class: "text-gray-lp-300 font-semibold"
}
const _hoisted_21 = { class: "text-gray-lp-3000 text-sm" }
const _hoisted_22 = { class: "flex flex-wrap gap-2  p-2 rounded-lg border border-gray-lp-1400 max-h-80 overflow-y-auto" }
const _hoisted_23 = { class: "inline-block bg-gray-lp-2500 text-gray-lp-300 font-medium text-12px rounded-md px-3 py-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('Daftar POS')), 1),
    (_ctx.detailData?.posOwnedList.length > 0)
      ? (_openBlock(), _createBlock("div", _hoisted_3, [
          _createVNode("table", _hoisted_4, [
            _createVNode("thead", _hoisted_5, [
              _createVNode("tr", null, [
                _hoisted_6,
                _hoisted_7,
                _createVNode("th", _hoisted_8, _toDisplayString(_ctx.$t('Nama POS')), 1),
                _hoisted_9,
                _hoisted_10
              ])
            ]),
            _createVNode("tbody", _hoisted_11, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.detailData.posOwnedList, (item, index) => {
                return (_openBlock(), _createBlock("tr", {
                  key: index,
                  class: " text-gray-lp-300 text-sm"
                }, [
                  _createVNode("td", _hoisted_12, _toDisplayString(index + 1), 1),
                  _createVNode("td", _hoisted_13, _toDisplayString(item.id || "-"), 1),
                  _createVNode("td", _hoisted_14, _toDisplayString(item.name || "-"), 1),
                  _createVNode("td", _hoisted_15, [
                    _createVNode("div", _hoisted_16, [
                      _createVNode("div", _hoisted_17, [
                        _createVNode("span", _hoisted_18, _toDisplayString((item.districtName && item.districtName.length > 15
                        ? item.districtName.slice(0, 15) + "..."
                        : item.districtName) || "-"), 1),
                        (item.districtName && item.districtName.length > 15)
                          ? (_openBlock(), _createBlock("button", {
                              key: 0,
                              type: "button",
                              class: "ml-2 text-red-lp-100 text-sm font-semibold underline flex-shrink-0",
                              onClick: ($event: any) => (_ctx.openDistrictDialog(index))
                            }, _toDisplayString(_ctx.$t('LIHAT SEMUA')), 9, ["onClick"]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  _createVNode("td", _hoisted_19, _toDisplayString(item.cityCode || "-") + " - " + _toDisplayString(item.cityName || "-"), 1)
                ]))
              }), 128))
            ])
          ])
        ]))
      : (_openBlock(), _createBlock("div", _hoisted_20, " - ")),
    _createVNode(_component_Dialog, {
      "model-value": _ctx.isShowDistrictDialog,
      title: _ctx.dialogTitle,
      "onUpdate:modelValue": _ctx.closeDistrictDialog,
      customWidth: "w-120"
    }, {
      default: _withCtx(() => [
        _createVNode("div", null, [
          _createVNode("div", _hoisted_21, _toDisplayString(_ctx.$t('Daftar district')), 1),
          _createVNode("div", _hoisted_22, [
            _createVNode("span", _hoisted_23, _toDisplayString(_ctx.dialogDistricts|| "-"), 1)
          ])
        ])
      ]),
      _: 1
    }, 8, ["model-value", "title", "onUpdate:modelValue"])
  ]))
}